import { useEffect, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import './FaqBackToTop.css';

export function FaqBackToTop() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 480);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      className="saas-faq-top"
      onClick={scrollTop}
      aria-label={t('faq.backToTop')}
    >
      ↑ {t('faq.backToTop')}
    </button>
  );
}
